const targets = ['webview', 'ios', 'android'];
export const Devices = {
    WEBVIEW: 'webview',
    IOS: 'ios',
    ANDROID: 'android',
};
const is = (target) => {
    const element = document.querySelector(`[data-${target}]`);
    if (!element) {
        return false;
    }
    return element.textContent === 'true';
};
export const getDevice = () => {
    let device = '';
    targets.forEach((target) => {
        if (target === 'webview') {
            return;
        }
        const element = document.querySelector(`[data-${target}]`);
        if (element && element.textContent === 'true') {
            device = target;
        }
    });
    return device;
};
export const getDeviceType = () => {
    const device = getDevice();
    if (device === 'ios') {
        return Devices.IOS;
    }
    else if (device === 'android') {
        return Devices.ANDROID;
    }
    else {
        return Devices.WEBVIEW;
    }
};
export const versionEnough = (target, requiredVersionInt) => {
    const element = document.querySelector(`[data-${target}-version]`);
    if (!element || !element.textContent) {
        return true;
    }
    return parseInt(element.textContent, undefined) >= requiredVersionInt;
};
export const isWebview = () => is('webview');
export const isIos = () => is('ios');
export const isAndroid = () => is('android');
export default () => isWebview();
